import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { Input } from '@marvelapp/ui';
import Label from './Label';
import { sizes } from './sizes';
/** @type {any} */
var InputWithLabel = forwardRef(function (_a, ref) {
    var id = _a.id, isOptional = _a.isOptional, label = _a.label, _b = _a.size, size = _b === void 0 ? 3 : _b, fontSize = _a.fontSize, props = __rest(_a, ["id", "isOptional", "label", "size", "fontSize"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, { fontSize: fontSize, id: id, isOptional: isOptional, size: size }, label),
        React.createElement(Input, __assign({ id: id, ref: ref, size: sizes[size].inputSize, width: 1 }, props))));
});
export default InputWithLabel;
